import { Component } from "react";
import CustomizedSelect from "./customizedSelect";
import { Input } from "../../forms/input";
import Signbutton from "../../forms/button";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import { SWP, YES } from "../../../store/types";
import {
  swpOptions,
  CalcSIPEnddt,
  getMinimumAmount,
  swpTransaction,
  addItemsToCart,
  validateSubBroker,
  getCartItemsList,
} from "../../../store/actions";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import { AddToCartStatusModal } from "../customModal";
import { SUBMIT, addToCart, singleTransaction } from "../../../store/types";
import { SwitchDetails, getFrequencyName } from "./tranUtils";
import { NEW_TRANSACTION_URL } from ".";
import { handleError } from "../../../utils/cart";

class Swp extends Component {
  constructor(props) {
    super(props);
    const { fundList } = this.props;
    const funds = fundList.reduce((prev, curr) => {
      if (curr.rFlag === YES) {
        const findIndex =
          prev.findIndex((fund) => fund.Fund === curr.Fund) !== -1;
        if (!findIndex) {
          return [...prev, { Fund: curr.Fund, FundDesc: curr.FundDesc }];
        }
      }
      return prev;
    }, []);

    this.state = {
      funds,
      openDialog: false,
      minAmountValue: { value: "" },
      radioValue: { value: "" },
      arnCode: { value: this.props.token },
      fund: { value: "" },
      folios: [],
      folio: { value: "" },
      schemes: [],
      scheme: { value: "" },
      swpOption: { value: "" },
      swpOptions: [],
      swpFrequency: { value: "" },
      swpFrequencyOptions: [],
      withdrawals: { value: "" },
      sipDay: { value: "" },
      sipStartDate: { value: "" },
      sipEndDate: { value: "" },
      amount: { value: "" },
      sipCycle: [],
      PosterOpen: false,
    };
  }
  handleFundChange = (value) => {
    // if(!!value && !!value.value && (String(value.value).trim() === "176" || String(value.value).trim() === "103")){
    //   this.setState({
    //     PosterOpen:true
    //   })
    // }
    if (!value) {
      this.setState({
        fund: { value: "" },
        folios: [],
        folio: { value: "" },
        schemes: [],
        scheme: { value: "" },
        swpOption: { value: "" },
        swpOptions: [],
        swpFrequency: { value: "" },
        swpFrequencyOptions: [],
        withdrawals: { value: "" },
        sipDay: { value: "" },
        sipStartDate: { value: "" },
        sipEndDate: { value: "" },
        amount: { value: "" },
        sipCycle: [],
      });
    } else if (value.value === this.state.fund.value.value) {
      return;
    } else {
      const fund = !!value ? value.value : "";
      const folios = this.props.fundList.reduce((prev, curr) => {
        if (curr.sFlag === YES && curr.Fund === fund) {
          return [...prev, curr.Acno];
        }
        return prev;
      }, []);
      this.setState({
        fund: { value },
        folios: Array.from(new Set(folios)),
        folio: { value: "" },
        scheme: { value: "" },
        withdrawals: { value: "" },
        swpFrequency: { value: "" },
        swpFrequencyOptions: [],
        swpOption: { value: "" },
      });
    }
  };
  closePoster = () => {
    this.setState({
      PosterOpen: false,
    });
  };

  handleFolioChange = async (value) => {
    const folio = !!value ? value.value : "";
    const schemes = !!value ? this.schemes(folio) : [];
    // const banks = this.props.bankDetails.filter(item => item.foliono === folio);
    this.setState({
      folio: { value },
      schemes,
      scheme: { value: "" },
    });
  };
  schemes = (folio) => {
    return this.props.fundList.reduce((prev, curr) => {
      if (curr.Fund === this.state.fund.value.value && curr.Acno === folio) {
        return [...prev, curr];
      }
      return prev;
    }, []);
  };

  handleSchemeChange = async (value) => {
    if (!value) {
      this.setState({
        swpOption: { value: "" },
        swpOptions: [],
        swpFrequency: { value: "" },
        swpFrequencyOptions: [],
        withdrawals: { value: "" },
        sipDay: { value: "" },
        sipStartDate: { value: "" },
        sipEndDate: { value: "" },
        amount: { value: "" },
        sipCycle: [],
      });
    } else if (
      !!value &&
      !!this.state.scheme.value.value &&
      value.value.SchDesc === this.state.scheme.value.value.SchDesc
    ) {
      return;
    } else {
      if (value.value.BalUnits === 0) {
        this.setState({
          folio: {
            value: "",
            isError: true,
            errorMessage: "SWP in zero balance folios is not allowed",
          },
          scheme: {
            value: "",
          },
        });
      } else {
        const params = {
          fund: this.state.fund.value.value,
          opt: "SWPW",
        };
        let swpOptionsResponse = [];
        const response = await this.props.swpOptions(params);
        if (response) {
          swpOptionsResponse = response.Dtinformation;
        }
        this.setState({
          scheme: { value },
          swpOptions: swpOptionsResponse,
        });
      }
    }
  };
  handleSwpOptonChange = async (event) => {
    if (
      !!this.state.swpOption.value &&
      event.target.value.code === this.state.swpOption.value.code
    ) {
      return;
    } else {
      const swpOption = event.target.value;
      const params = {
        opt: "SWF",
        fund: this.state.fund.value.value,
      };
      const response = await this.props.swpOptions(params);
      const swpFrequencyOptionsResponse = response.Dtinformation;

      this.setState({
        swpOption: { value: swpOption },
        withdrawals: { value: "" },
        swpFrequency: { value: "" },
        swpFrequencyOptions: swpFrequencyOptionsResponse,
      });
    }
  };

  handleSwpFrequencyChange = async (event) => {
    const swpFrequency = event.target.value;
    if (!!swpFrequency) {
      const minParams = {
        Fund: this.state.fund.value.value,
        Scheme: this.state.scheme.value.value.Sch,
        Trtype: "SWP",
        Frequency: swpFrequency?.FrequencyID,
      };
      const response = await this.props.getMinimumAmount(minParams);
      if (response) {
        const { DtData } = response;
        this.setState({
          minAmountValue: {
            value: DtData[0].minamt,
          },
        });
      }
    }
    const params = {
      opt: "SWPD",
      fund: this.state.fund.value.value,
      Astscheme:
        !!event.target.value && !!event.target.value.FrequencyDescription
          ? event.target.value.FrequencyDescription
          : "",
    };
    const response = await this.props.swpOptions(params);
    const sipCycleResponse = response.Dtinformation;

    this.setState({
      swpFrequency: { value: swpFrequency },
      sipDay: { value: "" },
      sipStartDate: { value: "" },
      sipEndDate: { value: "" },
      sipCycle: sipCycleResponse,
      minimumInstallments: swpFrequency.Minimum_Instalment,
    });
  };

  handleNoOfWithDrawals(event) {
    if (event.target.value.length <= 3 && !!event.target.value) {
      if (parseFloat(event.target.value) <= 500 && event.target.value !== "0") {
        this.setState({
          withdrawals: {
            value: parseFloat(event.target.value.replace(/^0+/, "")),
          },
          sipStartDate: { value: "" },
          sipEndDate: { value: "" },
          sipDay: { value: "" },
        });
      } else {
        this.setState({
          withdrawals: {
            value: "",
            isError: true,
            errorMessage: !!event.target.value
              ? "no of withdrwals should not be more than 500"
              : "",
          },
          sipStartDate: { value: "" },
          sipEndDate: { value: "" },
          sipDay: { value: "" },
        });
      }
    } else if (!event.target.value) {
      this.setState({
        withdrawals: {
          value: "",
          isError: true,
          errorMessage:
            !!event.target.value && event.target.value !== "0"
              ? "no of withdrawals should not be more than 500"
              : event.target.value === "0"
              ? "no of withdrwals should not be zero"
              : "please enter the minimum no of withdrawals",
        },
        sipStartDate: { value: "" },
        sipEndDate: { value: "" },
        sipDay: { value: "" },
      });
    }
  }
  async handleSwpDay(event) {
    const day = event.target.value;

    if (!!day) {
      const params = {
        Fund: this.state.fund.value.value,
        StartDate: day,
        installments: this.state.withdrawals.value,
        Frequency: this.state.swpFrequency.value.FrequencyDescription,
        trtype: "SWP",
        sch: this.state.scheme.value.value.Sch,
      };

      const response = await this.props.CalcSIPEnddt(params);

      const sipStartDateResponse = response.DtData[0].SIP_StartDate;
      const sipEndDateResponse = response.DtData[0].SIP_EndDate;
      this.setState({
        sipDay: { value: day },
        sipStartDate: { value: sipStartDateResponse },
        sipEndDate: { value: sipEndDateResponse },
      });
    }
  }

  showError = (label) => () => {
    const {
      [label]: { value },
    } = this.state;

    if (label === "withdrawals") {
      this.setState({
        [label]: {
          value,
          isError: this.state.withdrawals.value < 2 ? true : !value,
          errorMessage:
            this.state.withdrawals.value < 2
              ? "*Please enter the vaild number of withdrawals"
              : "",
        },
      });
    }
    // else if (label === "amount") {
    //   this.setState({
    //     [label]: {
    //       value,
    //       isError:
    //         this.state.minAmountValue.value < this.state.amount.value
    //           ? true
    //           : !value,
    //       errorMessage:
    //         this.state.minAmountValue.value < this.state.amount.value
    //           ? `Amount should be ${this.state.minAmountValue.value}`
    //           : ""
    //     }
    //   });
    // }
    else {
      this.setState({
        [label]: {
          value,
          isError: !value,
          errorMessage: `${label} is mandatory*`,
        },
      });
    }
  };

  handleMinimumAmount(event) {
    if (event.target.value.length <= 10) {
      this.setState({
        amount: { value: parseFloat(event.target.value.replace(/^0+/, "")) },
      });
    }
  }

  convertDate(date) {
    const [day, month, year] = date.split("/");
    return `${month}/${day}/${year}`;
  }
  submit = () => {
    let currValue;
    if (!!this.state.scheme.value) {
      currValue = parseFloat(
        this.state.scheme.value.value.CurValue.replaceAll(",", "")
      );
    }
    if (!this.state.amount.value) {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage: "(withdrawal amount is mandatory)",
        },
      });
    }
    const {
      funds,
      openDialog,
      folios,
      radioValue,
      arnCode,
      subArnCode,
      schemes,
      swpOptions,
      swpFrequencyOptions,
      withdrawals,
      sipStartDate,
      sipEndDate,
      amount,
      sipCycle,
      PosterOpen,
      bank,
      banks,
      minimumInstallments,
      ...others
    } = this.state;
    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage:
                key === "sipDay"
                  ? "SWP Day is mandatory*"
                  : key === "swpFrequency"
                  ? "Withdrawal Frequency is mandatory*"
                  : key === "swpOption"
                  ? "Withdrawal Option is mandatory*"
                  : `${key[0].toUpperCase() + key.substring(1)} is Mandatory`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "fund": {
          this.fundField.focus();
          break;
        }
        case "folio": {
          this.folioField.focus();
          break;
        }
        case "scheme": {
          this.schemeField.focus();
          break;
        }
        case "swpOption": {
          this.swpOptionField.focus();
          break;
        }
        case "sipDay": {
          this.sipDayField.focus();
          break;
        }
        case "swpFrequency": {
          this.swpFrquencyField.focus();
          break;
        }
      }
    } else if (this.state.withdrawals.value < 2) {
      this.setState({
        withdrawals: {
          value: "",
          isError: true,
          errorMessage: `Please check the minimum withDrawals Value`,
        },
      });
    } else if (
      this.state.withdrawals.value === "" ||
      parseFloat(this.state.withdrawals.value) <
        parseFloat(this.state.minimumInstallments)
    ) {
      this.setState({
        withdrawals: {
          value: "",
          isError: true,
          errorMessage: "please check the no of withdrawals value",
        },
      });
      return;
    } else if (
      (parseFloat(this.state.amount.value) < this.state.minAmountValue.value ||
        !this.state.amount.value) &&
      this.state.swpOption.value.Description === "Fixed"
    ) {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage: `(Minimum amount  is ${this.state.minAmountValue.value}(INR))`,
        },
      });
    } else {
      const { funds, folios, schemes, swpFrequencyOptions, ...others } =
        this.state;

      this.props.history.push({
        pathname: NEW_TRANSACTION_URL + "/swp/digital/transact/confirm",
        state: {
          title: "SWP Payment Summary",
          type: SWP,
          Folio: { value: others.scheme.value.value.Acno },
          withDrawals: others.withdrawals.value,
          scheme: others.scheme.value.value,
          swpFrequency: others.swpFrequency.value,
          sipEndDate: others.sipEndDate.value,
          swpOption: others.swpOption.value,
          sipStartDate: others.sipStartDate.value,
          amount: others.amount.value,
          sipDay: others.sipDay.value,
        },
      });
    }
  };

  onButtonClick = async (btnLabel) => {
    try {
      if (!this.state.amount.value) {
        this.setState({
          amount: {
            value: "",
            isError: true,
            errorMessage: "(withdrawal amount is mandatory)",
          },
        });
      }

      const {
        funds,
        openDialog,
        folios,
        radioValue,
        arnCode,
        subArnCode,
        schemes,
        swpOptions,
        swpFrequencyOptions,
        withdrawals,
        sipStartDate,
        sipEndDate,
        amount,
        sipCycle,
        PosterOpen,
        bank,
        banks,
        minimumInstallments,
        ...others
      } = this.state;
      const keys = Object.keys(others);
      const findError = keys.every((key) => !!others[key].value);
      if (!findError) {
        keys.forEach((key) => {
          !others[key].value &&
            this.setState({
              [key]: {
                ...others[key],
                isError: true,
                errorMessage:
                  key === "sipDay"
                    ? "SWP Day is mandatory*"
                    : key === "swpFrequency"
                    ? "Withdrawal Frequency is mandatory*"
                    : key === "swpOption"
                    ? "Withdrawal Option is mandatory*"
                    : `${key[0].toUpperCase() + key.substring(1)} is Mandatory`,
              },
            });
        });
        const firstErroredKey = keys.find((key) => !others[key].value);
        switch (firstErroredKey) {
          case "fund": {
            this.fundField.focus();
            break;
          }
          case "folio": {
            this.folioField.focus();
            break;
          }
          case "scheme": {
            this.schemeField.focus();
            break;
          }
          case "swpOption": {
            this.swpOptionField.focus();
            break;
          }
          case "sipDay": {
            this.sipDayField.focus();
            break;
          }
          case "swpFrequency": {
            this.swpFrquencyField.focus();
            break;
          }
          default:
            break;
        }
        return;
      } else if (this.state.withdrawals.value < 2) {
        this.setState({
          withdrawals: {
            value: "",
            isError: true,
            errorMessage: `Please check the minimum withDrawals Value`,
          },
        });
      } else if (
        this.state.withdrawals.value === "" ||
        parseFloat(this.state.withdrawals.value) <
          parseFloat(this.state.minimumInstallments)
      ) {
        this.setState({
          withdrawals: {
            value: "",
            isError: true,
            errorMessage: "please check the no of withdrawals value",
          },
        });
        return;
      }
      const minAmount = parseFloat(this.state.minAmountValue.value);
      const enteredValue = parseFloat(this.state.amount.value);
      const balanceAmount = parseFloat(
        this.state.scheme.value.value.CurValue.replaceAll(",", "")
      );

      if (this.state.swpOption.value.Description === "Fixed") {
        if (enteredValue > balanceAmount) {
          this.setState({
            amount: {
              value: "",
              isError: true,
              errorMessage: `Amount should be less than or equal to ${balanceAmount}`,
            },
          });
          return;
        }

        if (balanceAmount * (1 + 0.05) < minAmount) {
          this.setState({
            amount: {
              value: "",
              isError: true,
              errorMessage: `You do not have enough balance to start SWP.`,
            },
          });
          return;
        }

        if (enteredValue * (1 + 0.05) < minAmount) {
          this.setState({
            amount: {
              value: "",
              isError: true,
              errorMessage: `Amount should be greater than or equal to ${minAmount}`,
            },
          });
          return;
        }
      }

      const { communicationDetails, investorData } = this.props;
      const Xmobile = communicationDetails.find(
        (detail) =>
          detail.Fund === this.state.fund.value.value &&
          detail.Acno === this.state.folio.value.value &&
          detail.PAN === investorData.PAN &&
          !!detail.Mobile
      );
      const Xemail = communicationDetails.find(
        (detail) =>
          detail.Fund === this.state.fund.value.value &&
          detail.Acno === this.state.folio.value.value &&
          detail.PAN === investorData.PAN &&
          !!detail.email
      );

      const Email = !!Xemail && !!Xemail.email ? Xemail.email : "";
      const Mobile = !!Xmobile && !!Xmobile.Mobile ? Xmobile.Mobile : "";
      const selectedFund = funds.find(
        (i) => i.Fund === others.fund.value.value
      ).FundDesc;

      const params = {
        pan: this.props.investorData.PAN,
        mobile: Mobile,
        email: Email,
        folio: others.folio.value.value,
        arn: this.state.arnCode.value,
        fund: others.fund.value.value,
        scheme: others.scheme.value.value.Sch,
        plan: others.scheme.value.value.Pln,
        option: others.scheme.value.value.Opt,
        amount:
          this.state.swpOption.value.Description === "Capital Appreciation"
            ? 0
            : this.state.amount.value,
        // subArn: !!this.state.subArnCode.value ? subArnCode.value : "",
        // subBroker: "",
        withdrawalType: this.state.swpOption.value.Description,
        transactionType: singleTransaction.SWP,
        branch: "DA99",
        dcr: singleTransaction.DCR, //Imp
        userId: this.state.arnCode.value, //this.props.userId,
        frequency: getFrequencyName(this.state.swpFrequency.value.FrequencyID),
        noOfWithdrawals: this.state.withdrawals.value,
        investorName: investorData.invname,
        swpFrequency: others.swpFrequency.value.FrequencyID,
        swpOption: others.swpOption.value.Description,
        swpEndDate: this.convertDate(sipEndDate.value),
        swpStartDate: this.convertDate(sipStartDate.value),
        swpDay: others.sipDay.value,
        arnCode: this.state.arnCode.value,
        schemeName: this.state.scheme.value.label,
        taxSaverFlag: others.scheme.value.value.TaxSaverFlag,
        fundName: selectedFund,
      };

      if (btnLabel === SUBMIT) {
        const response = await this.props.swpTransaction(params);
        if (response) {
          this.props.history.goBack();
        }
      } else if (btnLabel === addToCart) {
        const response = await this.props.addItemsToCart(params);

        if (response) {
          const [newCartItem] = response.cartItems.sort(
            (item1, item2) =>
              Number(item2.cartItemId) - Number(item1.cartItemId)
          );
          this.setState({
            openDialog: true,
            cartId: response.bulkOrderId,
            ihno: newCartItem.ihno,
          });
        }
      }
    } catch (error) {
      handleError(error);
    }
  };

  close = () => {
    this.setState({ openDialog: false });
  };

  changeValue = (label) => (event) => {
    if (
      (label === "subArnCode" || label === "subBrokerCode") &&
      event.target.value.length <= 20
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
    if (label === "radioValue" && event.target.value === "no") {
      this.setState({
        radioValue: { value: event.target.value },
      });
    } else if (
      label !== "subArnCode" &&
      label !== "subBrokerCode" &&
      label === "radioValue" &&
      event.target.value !== "no"
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  render() {
    const {
      funds,
      fund,
      folio,
      folios,
      scheme,
      schemes,
      swpOption,
      swpOptions,
      swpFrequency,
      swpFrequencyOptions,
      withdrawals,
      sipDay,
      sipStartDate,
      sipEndDate,
      sipCycle,
      amount,
    } = this.state;
    console.log(this.state.swpFrequency, "hello");
    const selectedScheme = scheme?.value?.value;

    return (
      <div className="transaction-details">
        {/* <PosterDialog open={this.state.PosterOpen} close={this.closePoster} /> */}
        <div className="title">SWP Plan</div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">AMC</div>
          <IntegrationReactSelect
            suggestions={funds.map((item) => ({
              label: item.FundDesc,
              value: item.Fund,
            }))}
            value={fund.value}
            placeholder="Select AMC"
            handleChange={this.handleFundChange}
            inputRef={(ele) => (this.fundField = ele)}
            isError={fund.isError}
            errorMessage={fund.errorMessage}
          />
        </div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">Folio</div>
          <IntegrationReactSelect
            suggestions={folios.map((item) => ({
              label: item,
              value: item,
            }))}
            disabled={!fund.value}
            value={folio.value}
            placeholder="Select Folio"
            handleChange={this.handleFolioChange}
            inputRef={(ele) => (this.folioField = ele)}
            isError={folio.isError}
            errorMessage={folio.errorMessage}
          />
        </div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">Scheme</div>
          <IntegrationReactSelect
            suggestions={schemes.map((item) => ({
              label: item.PlnDesc
                ? `${item.SchDesc1} - ${item.PlnDesc} - ${item.OptDesc}`
                : item.fm_schdesc,
              value: item,
            }))}
            disabled={!folio.value}
            value={scheme.value}
            placeholder="Select Scheme"
            handleChange={this.handleSchemeChange}
            inputRef={(ele) => (this.schemeField = ele)}
            isError={scheme.isError}
            errorMessage={scheme.errorMessage}
          />
        </div>
        {!!folio.value ? (
          <div className="redemption-details">
            <div className="keys">
              {<SwitchDetails name={"Balance Units"} />}
              {<SwitchDetails name={"Current Value"} />}
              <SwitchDetails name={"NAV as on Date"} />
            </div>
            <div className="values">
              <SwitchDetails name={selectedScheme?.BalUnits || ""} />
              <SwitchDetails name={selectedScheme?.CurValue || ""} />
              <SwitchDetails name={selectedScheme?.LastNAV || ""} />
            </div>
          </div>
        ) : selectedScheme?.multibrokflag === YES ? (
          <>
            <div
              style={{
                fontFamily: "OpenSans-SemiBold",
                fontSize: 13,
                color: "red",
                margin: 10,
              }}
            >
              Note: This folio has multiple distributors. Hence, the balance
              units and current value will not be displayed. In case of full
              redemption, all the units in the investor's portfolio will be
              redeemed.
            </div>
          </>
        ) : null}
        <div className="input-margin">
          <CustomizedSelect
            name="Withdrawal Option"
            placeholder="Withdrawal Option"
            handleChange={this.handleSwpOptonChange}
            value={swpOption.value.value}
            disabled={!scheme.value}
            inputRef={(ele) => (this.swpOptionField = ele)}
            isError={swpOption.isError}
            errorMessage={swpOption.errorMessage}
          >
            {swpOptions.map((item, index) => (
              <MenuItem value={item} key={index}>
                {item.Description}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>
        <div className="input-margin">
          <CustomizedSelect
            name="Withdrawal Frequency"
            placeholder="Withdrawal Frequency"
            handleChange={this.handleSwpFrequencyChange}
            value={swpFrequency.value}
            inputRef={(ele) => (this.swpFrquencyField = ele)}
            isError={swpFrequency.isError}
            disabled={!swpOption.value}
            errorMessage={swpFrequency.errorMessage}
          >
            {swpFrequencyOptions.map((item, index) => (
              <MenuItem value={item} key={index}>
                {item.FrequencyDescription}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>
        <div className="input-margin">
          <Input
            name={
              this.state.minimumInstallments
                ? `Number of withdrawals (Minimum: ${this.state.minimumInstallments})`
                : "Number of withdrawals"
            }
            onChange={(event) => this.handleNoOfWithDrawals(event)}
            onBlur={this.showError("withdrawals")}
            isShowError={withdrawals.isError}
            errorMessage={withdrawals.errorMessage}
            disabled={!swpFrequency.value}
            value={withdrawals.value}
          />
        </div>
        <div className="input-margin">
          <CustomizedSelect
            name="SWP Day"
            placeholder="SWP Day"
            value={withdrawals.value ? sipDay.value : ""}
            disabled={!withdrawals.value}
            inputRef={(ele) => (this.sipDayField = ele)}
            isError={sipDay.isError}
            errorMessage={sipDay.errorMessage}
            handleChange={(event) => this.handleSwpDay(event)}
          >
            {sipCycle.map((item, index) => (
              <MenuItem value={item.sip_cycleid} key={index}>
                {item.sip_cycleid}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>
        <div className="input-name">Withdrawal Period</div>
        <div className="input-name">
          <Input
            name="From Date"
            value={swpFrequency.value ? sipStartDate.value : ""}
            disabled={true}
          />
        </div>
        <div className="input-margin">
          <Input
            name="To Date"
            value={swpFrequency.value ? sipEndDate.value : ""}
            disabled={true}
          />
        </div>
        {swpOption?.value?.Description?.toUpperCase() === "FIXED" ? (
          <div>
            <div
              style={{
                margin: "20px 5px 10px",
                color: "#0076cb",
                fontSize: 14,
                fontFamily: "OpenSans-SemiBold",
                backgroundColor: "aliceblue",
                padding: "10px 0px",
                textAlign: "center",
              }}
            >
              Minimum Amount :
              {!!this.state.minAmountValue
                ? this.state.minAmountValue.value
                : ""}
              (INR)
            </div>
            <div className="input-margin">
              <Input
                name="Withdrawal Amount (INR)"
                onKeyDown={(evt) =>
                  (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                  evt.preventDefault()
                }
                bordercolor="#a6a6a6"
                type="number"
                errorMessage={amount.errorMessage}
                isShowError={amount.isError}
                onBlur={this.showError("amount")}
                // disabled={redemptionType === FULL ? true : false}
                onChange={(event) => this.handleMinimumAmount(event)}
                value={amount.value}
              />
            </div>
          </div>
        ) : (
          ""
        )}
        {/* <div className="digital-form-button-next-div">
          <Signbutton buttontitle="Submit" onClick={this.submit} />
        </div> */}

        <div className="trantype-button-view">
          <Signbutton
            buttontitle="Add to cart"
            onClick={() => this.onButtonClick(`${addToCart}`)}
            width={240}
            border={"1px solid #007CC5"}
            texttransform={true}
          />
          <span className="addtocart-btn" />
          <Signbutton
            buttontitle="Submit"
            onClick={() => this.onButtonClick(`${SUBMIT}`)}
            width={240}
            border={"1px solid #007CC5"}
            texttransform={true}
          />
        </div>
        <AddToCartStatusModal
          closeModal={this.close}
          open={this.state.openDialog}
          image={"/images/cart_success.svg"}
          btn_one={"Go to cart"}
          btn_two={"Add more"}
          pan={this.props.investorData.PAN}
          onAddTransaction={() =>
            this.props.history.push("/cart/add-transaction/swp", {
              pan: this.props.investorData.PAN,
            })
          }
          message={`Transaction has been added to cart successfully with the reference number ${this.state.ihno} and bulk-order ID ${this.state.cartId}`}
          ihno={this.state.ihno}
          cartId={this.state.cartId}
        />
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const {
      fundList,
      token,
      userId,
      bankDetails,
      investorData,
      communicationDetails,
      isCartUser,
    } = authReducer;
    const { euinList } = transactions;
    return {
      fundList,
      isCartUser,
      token,
      userId,
      euinList,
      bankDetails,
      investorData,
      communicationDetails,
    };
  },
  {
    swpOptions,
    CalcSIPEnddt,
    getMinimumAmount,
    swpTransaction,
    addItemsToCart,
    validateSubBroker,
    getCartItemsList,
  }
)(Swp);
